export default __webpack_public_path__ + "static/image-11-9f4b83c01edb359e33b4f761524c183b.jpg";